/* eslint-disable no-nested-ternary */
import { useCallback, useState } from 'react';
import { StyleSheet } from 'react-native';
import { TextInput } from 'react-native-paper';
import TextButton from '../elements/TextButton';
import { Text, View } from '../Themed';
import Colors from '../../constants/Colors';

export type InfoInputParamList = {
  questionCategory: string;
  title: string[];
  onSubmit?: (response: any) => void;
};

export default function MultiInputScreen(props: InfoInputParamList) {
  const { questionCategory, title, onSubmit } = props;
  const [heightFeet, setHeightFeet] = useState<number>();
  const [heightInch, setHeightInch] = useState<number>();
  const [weight, setWeight] = useState<number>();
  const [valid, setValid] = useState<boolean>(true);

  const onChangeHeightFeet = (newFeet: string) => {
    if (newFeet === '') {
      setHeightFeet(undefined);
    } else {
      setHeightFeet(parseInt(newFeet, 10));
    }
  };

  const onChangeHeightInch = (newInch: string) => {
    if (newInch === '') {
      setHeightInch(undefined);
    } else {
      setHeightInch(parseInt(newInch, 10));
    }
  };

  const onChangeWeight = (newWeight: string) => {
    if (newWeight === '') {
      setWeight(undefined);
    } else {
      setWeight(parseFloat(newWeight));
    }
  };

  const handleSubmit = useCallback(() => {
    let currentBMI;
    if (weight === undefined || heightFeet === undefined || heightInch === undefined) {
      currentBMI = -1;
    } else {
      currentBMI = (weight / (heightFeet * 12 + heightInch) ** 2) * 703;
    }
    // console.log(currentBMI);
    const responses = [heightFeet, heightInch, weight, currentBMI];
    // console.log(responses);
    const isValidBMI = currentBMI > 18.5;
    setValid(isValidBMI);
    if (typeof onSubmit === 'function' && isValidBMI) {
      onSubmit(responses);
    }
  }, [onSubmit, heightFeet, heightInch, weight]);
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.heightInputWrap}>
        <TextInput
          label="ft."
          value={heightFeet !== undefined && !Number.isNaN(heightFeet) ? heightFeet.toString() : ''}
          onChangeText={onChangeHeightFeet}
          keyboardType="numeric"
          style={[styles.input, { fontFamily: 'Quicksand' }]}
          underlineColor="#31373E"
          activeUnderlineColor={Colors.snapCalorie.buttonBlue}
          activeOutlineColor={Colors.snapCalorie.buttonBlue}
          maxLength={1}
          autoComplete={false}
        />
        <TextInput
          label="in."
          value={heightInch !== undefined && !Number.isNaN(heightInch) ? heightInch.toString() : ''}
          autoComplete={false}
          onChangeText={onChangeHeightInch}
          style={[styles.input, { fontFamily: 'Quicksand' }]}
          keyboardType="numeric"
          underlineColor="#31373E"
          activeUnderlineColor={Colors.snapCalorie.buttonBlue}
          activeOutlineColor={Colors.snapCalorie.buttonBlue}
          maxLength={2}
        />
      </View>
      <TextInput
        label="lbs."
        value={weight !== undefined && !Number.isNaN(weight) ? weight.toString() : ''}
        onChangeText={onChangeWeight}
        style={[styles.input, { width: 325 }, { fontFamily: 'Quicksand' }]}
        keyboardType="numeric"
        underlineColor="#31373E"
        activeUnderlineColor={Colors.snapCalorie.buttonBlue}
        activeOutlineColor={Colors.snapCalorie.buttonBlue}
        maxLength={3}
        autoComplete={false}
      />
      <TextButton
        textStyle={{
          fontSize: 20,
          fontWeight: '600',
          lineHeight: 25,
          letterSpacing: -0.29,
          color: '#F8F5F4',
        }}
        style={[
          styles.buttonWrapper,
          {
            backgroundColor: Colors.snapCalorie.buttonBlue,
          },
        ]}
        onPress={handleSubmit}
        text="Next"
      />
      {!valid && (
        <Text style={[styles.invalidText, { color: 'red' }]}>
          SnapCalorie is not designed for BMIs under 18.5, in accordance with CDC guidelines.
        </Text>
      )}
    </View>
  );
}
MultiInputScreen.defaultProps = {
  onSubmit: () => {},
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    lineHeight: 24,
    maxWidth: 300,
    fontWeight: '500',
    letterSpacing: 0,
    color: '#14181B',
    marginBottom: 40,
  },
  heightInputWrap: {
    flexDirection: 'row',
  },
  input: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    borderBottomEndRadius: 10,
    borderTopEndRadius: 10,
    borderBottomStartRadius: 10,
    borderTopStartRadius: 10,
    overflow: 'hidden',
    width: 150,
    textAlign: 'center',
    backgroundColor: 'white',
  },
  buttonWrapper: {
    borderRadius: 21,
    width: 300,
    height: 50,
    marginTop: 40,
    marginBottom: 10,
    alignSelf: 'center',
  },
  invalidText: {
    fontWeight: '500',
    color: 'red',
    fontSize: 14,
    justifyContent: 'center',
    textAlign: 'center',
  },
});
